module.exports = __webpack_public_path__ + "img/03.fb12f302.png";